import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-app-user-list',
  imports: [CommonModule],
  templateUrl: './app-user-list.component.html',
  styleUrl: './app-user-list.component.scss',
})
export class AppUserListComponent {
  public parentList: any[] = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  ];
  public selectedParent: number = 0;

  handleParent(parent: number): void {
    this.selectedParent = parent;
  }
}
